var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0714 0H2.91942C1.30871 0 0 1.32701 0 2.95603V38.044C0 39.673 1.30871 41 2.91942 41H38.0714C39.6821 41 41 39.673 41 38.044V2.95603C41 1.32701 39.6821 0 38.0714 0ZM12.3915 35.1429H6.31473V15.5763H12.4007V35.1429H12.3915ZM9.35313 12.904C7.40379 12.904 5.82969 11.3208 5.82969 9.38058C5.82969 7.4404 7.40379 5.85714 9.35313 5.85714C11.2933 5.85714 12.8766 7.4404 12.8766 9.38058C12.8766 11.3299 11.3025 12.904 9.35313 12.904ZM35.1703 35.1429H29.0935V25.625C29.0935 23.3554 29.0478 20.4359 25.9362 20.4359C22.7696 20.4359 22.2846 22.9069 22.2846 25.4603V35.1429H16.2078V15.5763H22.0375V18.2487H22.1199C22.9344 16.7112 24.9203 15.0913 27.8763 15.0913C34.0263 15.0913 35.1703 19.1455 35.1703 24.417V35.1429Z",
    fill: "#758B9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.417da9043bf26914d227baf8316a2a56.svg";
export { ForwardRef as ReactComponent };